var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-textarea',{staticClass:"editor",attrs:{"rows":"5"},model:{value:(_vm.componentData.value),callback:function ($$v) {_vm.$set(_vm.componentData, "value", $$v)},expression:"componentData.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }